// Tipos del módulo de operación. Espejo de `mcp_django/apps/workforce`.

export interface Attendance {
  id: string;
  person: string;
  location_id: string;
  business_date: string;
  kind: 'in' | 'out';
  happened_at: string;
  classification: 'on_time' | 'late' | 'early_leave';
  minutes_late: number;
  photo_url: string;
  note: string;
}

export interface Absence {
  id: string;
  person: string;
  kind: 'absence' | 'vacation' | 'holiday';
  starts_on: string;
  ends_on: string;
  status: 'pending' | 'approved' | 'rejected';
  requested_by: string;
  decided_by: string;
  note: string;
}

export interface ChecklistStep {
  id: string;
  text: string;
  sort_order: number;
  requires_photo: boolean;
  done: boolean;
  photo_url: string;
  marked_at: string | null;
}

export interface ChecklistRun {
  id: string;
  template_id: string;
  template_name: string;
  location_id: string;
  business_date: string;
  person: string;
  completed_at: string | null;
  steps: ChecklistStep[];
}

export interface ChecklistTemplate {
  id: string;
  name: string;
  moment: 'open' | 'close';
  location_id: string | null;
  is_active: boolean;
}

export interface Task {
  id: string;
  text: string;
  assigned_to: string;
  location_id: string;
  due_on: string;
  done_at: string | null;
  done_by: string;
}

export interface IncidentOption {
  id: string;
  category: string;
  text: string;
  severity: 'low' | 'medium' | 'high';
  notify_immediately: boolean;
}

export interface Incident {
  id: string;
  category: string;
  option_text: string;
  severity: 'low' | 'medium' | 'high';
  location_id: string;
  reported_by: string;
  happened_at: string;
  photo_url: string;
  note: string;
  resolved_at: string | null;
}

export interface PeriodSummary {
  person: string;
  desde: string;
  hasta: string;
  jornadas: number;
  retardos: number;
  minutos_retardo: number;
  sin_salida: string[];
  vacaciones: number;
  faltas: number;
  festivos: number;
}

export const CATEGORIAS: Record<string, string> = {
  personal: 'Personal',
  producto: 'Producto',
  inventario: 'Inventario',
  equipo: 'Equipo',
  limpieza: 'Limpieza',
  ventas: 'Ventas',
  proveedores: 'Proveedores',
  seguridad: 'Seguridad',
};
